import axios from 'axios';
import Configuration from "../config";

/**
 * Service to integrate with AEM
 */
class AemService {

  apiURL = 'https://exampleService.com/';

  searchKey = 'gruppocap';

  onError(error) {
    return error.response;
  }

  isLocalhost() {
    return (window.location.href.indexOf('localhost') !== -1) || (window.location.href.indexOf('127.0.0.1') !== -1);
  }

  get(type, payload = null) {
    return axios.get(type, payload)
      .then(function (response) {
        return response;
      })
      .catch(this.onError)
  }

  post(type, payload) {
    return axios.post(`${this.apiURL}/${type}`, payload)
      .then(function (response) {
        return response;
      })
      .catch(this.onError)
  }

  put(type, payload) {
    return axios.put(`${this.apiURL}/${type}`, payload)
      .then(function (response) {
        return response;
      })
      .catch(this.onError)
  }

  patch(type, payload) {
    return axios.patch(`${this.apiURL}/${type}`, payload)
      .then(function (response) {
        return response;
      })
      .catch(this.onError)
  }

  delete(type, payload) {
    return axios.delete(`${this.apiURL}/${type}`, payload)
      .then(function (response) {
        return response;
      })
      .catch(this.onError)
  }


  /**
   * Obtain configurations object from AEM
   */
  getConfigurations() {
    let isLocalhost = this.isLocalhost();

    let pre = null;
    if (isLocalhost) {
      pre = '/aem/configurations';
    } else {
      if (window.location.href.indexOf(this.searchKey) !== -1) {
        pre = '/content/groupcap.getConfiguration.web.json';
      } else {
        pre = 'https://dev-www.gruppocap.it/content/groupcap.getConfiguration.web.json';
      }
    }

    return this.get(pre).then((response) => {
      if (response === undefined) throw (new Error('Unable to read configurations from AEM'))
      if (response) {
        return response.data;
      }
    }).catch((error) => {
      const path = `${process.env.PUBLIC_URL}/default/config/configuration.json`;
      return this.get(path)
        .then((response) => {
          if (response) {
            return response.data;
          }
          return error
        })
    });


  }


  /**
   * Obtain translations object from AEM
   */
  getTranslations(language) {

    let languageSelected = language === "it-IT" ? "it" : "en";
    let isLocalhost = this.isLocalhost();

    let pre = null;
    if (isLocalhost) {
      pre = `/aem/${languageSelected}/translations`;
    } else {
      if (window.location.href.indexOf(this.searchKey) !== -1) {
        pre = `/content/groupcap.getTranslation.${languageSelected}.web.json`;
      } else {
        pre = `https://dev-www.gruppocap.it/content/groupcap.getTranslation.${languageSelected}.web.json`;
      }
    }

    return this.get(pre).then((response) => {
      if (response === undefined) throw (new Error('Unable to read translations from AEM'))
      if (response) {
        return this.extractTranslations(response);
      }
    }).catch((error) => {
      const inputPaths = {
        it: `${process.env.PUBLIC_URL}/default/language/it.json`,
        en: `${process.env.PUBLIC_URL}/default/language/en.json`,
      }
      return this.get(inputPaths[languageSelected]).then(response => {
        if (response) {
          return this.extractTranslations(response);
        }
        return error
      })
    });
  }

  extractTranslations(response) {
    let jsonFile = response.data;
    let translationFile = jsonFile.translations;
    let errorTranslation = jsonFile.error;

    for (var key in errorTranslation) {
      if (errorTranslation.hasOwnProperty(key)) {
        let error = "error." + key;
        translationFile[error] = errorTranslation[key];
      }
    }
    return translationFile;
  }

  /**
   * Obtain menu object from AEM
   */
  getMenuObject(language) {
    let isLocalhost = this.isLocalhost();
    let languageSelected = language === "it-IT" ? "it" : "en";
    let pre = null;
    if (isLocalhost) {
      pre = `/aem/${languageSelected}/menu`;
    } else {
      if (window.location.href.indexOf(this.searchKey) !== -1) {
        pre = `/content/groupcap.getMenu.${languageSelected}.json`;
      } else {
        pre = `https://t-www.gruppocap.it/content/groupcap.getMenu.${languageSelected}.json`;
      }
    }
    return this.get(pre).then((response) => {
      if (response === undefined || response.status !== 200) throw (new Error('Unable to read menu from AEM'))
      if (response) {
        return response.data;
      }
    }).catch((error) => {
      const inputPath =  `${process.env.PUBLIC_URL}/default/menu/${languageSelected}.json`;
      return this.get(inputPath).then(response => {
          if (response) {
            return response.data;
          }
          return error
        })
    });
  }

    /**
   * Obtain menu object from AEM
   */
  getSociLinks(language) {
    let languageSelected = language === "it-IT" ? "it" : "en";
    let isLocalhost = this.isLocalhost();

    let pre = null;
    if (isLocalhost) {
      pre = `/soci/${languageSelected}`;
    } else {
      if (window.location.href.indexOf(this.searchKey) !== -1) {
        pre = `/content/groupcap.getSociDocuments.${languageSelected}.json`;
      } else {
        pre = `https://t-www.gruppocap.it/content/groupcap.getSociDocuments.${languageSelected}.json`;
      }
    }

    return this.get(pre).then((response) => {
      if (response === undefined) throw (new Error('Unable to read soci documents from AEM'))
      if (response) {
        return response.data;
      }
    }).catch((error) => {
      const inputPaths = {
        it: `${process.env.PUBLIC_URL}/default/soci/it.json`,
        en: `${process.env.PUBLIC_URL}/default/soci/en.json`,
      }
      return this.get(inputPaths[languageSelected]).then(response => {
        if (response) {
          return response.data;
        }
        return error
      })
    });
  }

  loadMenuObjects = async () => {
    return Promise.all([
      this.getMenuObject("en-EN"),
      this.getMenuObject("it-IT"),
    ])
      .then(([enMenu, itMenu]) => {
       return {'en-EN': enMenu, 'it-IT' : itMenu}
      })
      .catch((error) => error);
  };
  /**
   * Obtain list of comuni serviti
   */
  getComuniServitiList() {
    let isLocalhost = (window.location.href.indexOf('localhost') !== -1) || (window.location.href.indexOf('127.0.0.1') !== -1);

    let uri = null;
    if (isLocalhost) {
      uri = '/aem/getListComuni';
    } else {
      if (window.location.href.indexOf(this.searchKey) !== -1) {
        uri = '/content/groupcap/it.getListComuni.json';
      } else {
        uri = 'https://dev-www.gruppocap.it/content/groupcap/it.getListComuni.json';
      }
    }

    return this.get(uri).then((response) => {
      if (response) {
        return response.data;
      }
    }).catch((error) => {
      console.log('errore here', error)
      return error
    });
  }

  /**
   * Obtain list of comuni serviti
   */
  getComuniSpurghoServitiList() {
    let isLocalhost = (window.location.href.indexOf('localhost') !== -1) || (window.location.href.indexOf('127.0.0.1') !== -1);

    let uri = null;
    if (isLocalhost) {
      uri = '/aem/getListComuniSpurgo';
    } else {
      if (window.location.href.indexOf(this.searchKey) !== -1) {
        uri = '/content/groupcap/it.getListComuniSpurgo.json ';
      } else {
        uri = 'https://dev-www.gruppocap.it/content/groupcap/it.getListComuniSpurgo.json ';
      }
    }

    return this.get(uri).then((response) => {
      if (response) {
        return response.data;
      }
    }).catch((error) => {
      console.log('errore here', error)
      return error
    });
  }

getCities = async (value)  => {
  const env = Configuration.get('REACT_APP_ENVIRONMENT');
  let username = (env === "production") ? "WPT04GRC01" : "WPT04CGRC01";
  let password = (env === "production") ? "GTVUQ9WS" : "9QUANDP8";
  const url_suggest = (env === "production") ? "https://wpt11.egoncloud.com/api/suggest" : "https://wpt14.egoncloud.com/api/suggest";
  return this.get(`${url_suggest}/city?app_key=${username}@${password}&query=${value}`)
    .then(response => {
        if (response) {
            return response.data;
        }
    }).catch((error) => {
        console.log('errore here', error)
        return error
    });
  }

}

export default AemService;
